import { render, staticRenderFns } from "./filepond.vue?vue&type=template&id=0bde1173"
import script from "./filepond.vue?vue&type=script&lang=js"
export * from "./filepond.vue?vue&type=script&lang=js"
import style0 from "./filepond.vue?vue&type=style&index=0&id=0bde1173&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports